import { useEffect, useState } from "react";
import { DomainUrl } from "../Components/utills/CommonData";

export const useProductData = () => {
  const [productData, setProductData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  console.log(`${DomainUrl}/allproducts`);
  const fetchData = async () => {
    try {
      const response = await fetch(`${DomainUrl}/allproducts`);
      setLoading(true);
      const json = await response.json();

      console.log(response);

      if (response.status === 200) {
        setProductData(json.products);
      } else {
        return;
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return { productData, loading };
};
